import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import {
  keyLoading,
  selectCompanyHeader,
  selectIsRedirect404CompanyHeader,
  selectLoading,
} from './store/slice'
import { getCompanyHeaderThunk } from './store/thunk'

const useCompanyHeader = ({ disableCallApi, isFullInfo = true, orgId }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.COMPANY_HEADER))
  const companyHeader = useSelector(selectCompanyHeader)
  const isRedirect404CompanyHeader = useSelector(
    selectIsRedirect404CompanyHeader,
  )

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const id = orgId ? orgId : organizationId

  useEffect(() => {
    if (!disableCallApi && locale && id) {
      dispatch(
        getCompanyHeaderThunk({
          OrganizationId: id,
          FullInfo: isFullInfo,
        }),
      )
    }
  }, [locale, id])

  return {
    loading,
    isRedirect404CompanyHeader,
    companyHeader,
  }
}

export default useCompanyHeader
